export enum ReasonForEmployment {
  ExtraCash = 'Extra cash',
  SeekingAPermanentJob = 'Seeking a permanent job',
  SeekingExperience = 'Seeking experience',
}
